import { render, staticRenderFns } from "./NetworkInfo.vue?vue&type=template&id=e9ef9076&scoped=true"
import script from "./NetworkInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./NetworkInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NetworkInfo.vue?vue&type=style&index=0&id=e9ef9076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ef9076",
  null
  
)

export default component.exports